export enum BBCustomSoundEvents {
    BONUS_BELL = "bonus_bell",
    BASEGAME_MUSIC_FADE_IN = "basegame_music_fade_in",
    PROGRESSIVE_BELL = "prog_bell"
}

export enum LLCustomLayers {
    JACKPOTS = "Jackpots",
    LOGOS = "Logos",
    FIRE = "Fire",
    VAULT_GATEWAY = "VaultGateway",
    HOLD_AND_SPIN_BORDER = "HoldAndSpinBorder",
    MONEY_CHARGE_BONUS_SYMBOLS = "MoneyChargeBonusSymbols"
}
